/**
 * Ruckstuhl configurator route helper
 * Stable hand-off from the lightweight global configurator to the product configurator.
 *
 * Important:
 * - never click the configurator trigger before its own script has attached handlers
 * - never leave the document scroll-locked if an initialization fails
 * - only auto-open once per navigation
 */
(function(){
  'use strict';

  const params = new URLSearchParams(window.location.search || '');
  if(params.get('rk_configurator') !== '1') return;

  const TRIGGER_SELECTOR = '[data-rk-at-trigger], [data-rk-rb-trigger], [data-rk-tile-trigger], .rk-maglia__trigger';
  const CLOSE_SELECTOR = '[data-rk-at-close], [data-rk-rb-close], [data-rk-tile-close], [data-rk-maglia-close]';
  let opened = false;
  let attempts = 0;
  let timer = null;

  function visibleTrigger(){
    return Array.from(document.querySelectorAll(TRIGGER_SELECTOR)).find(function(node){
      if(!node || node.disabled) return false;
      const style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }) || null;
  }

  function isReady(trigger){
    if(!trigger) return false;
    return trigger.dataset.rkConfiguratorReady === '1';
  }

  function forceUnlock(){
    const anyOpen = document.querySelector('.rk-at-modal.is-open, .rk-rb-modal.is-open, .rk-tile-modal:not([hidden]), [data-rk-maglia-modal].is-open');
    if(anyOpen) return;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.documentElement.classList.remove('rk-at-modal-open');
  }

  function emergencyClose(){
    document.querySelectorAll('.rk-at-modal.is-open, .rk-rb-modal.is-open, .rk-tile-modal:not([hidden]), [data-rk-maglia-modal].is-open').forEach(function(modal){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      if(modal.classList.contains('rk-tile-modal')) modal.hidden = true;
    });
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.documentElement.classList.remove('rk-at-modal-open');
  }

  function stripAutoOpenParam(){
    try{
      const url = new URL(window.location.href);
      url.searchParams.delete('rk_configurator');
      window.history.replaceState({}, '', url.toString());
    }catch(error){}
  }

  function openWhenReady(){
    if(opened) return true;
    const trigger = visibleTrigger();
    if(!trigger || !isReady(trigger)) return false;

    opened = true;
    stripAutoOpenParam();
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){
        try{
          trigger.click();
          window.setTimeout(forceUnlock, 1200);
        }catch(error){
          console.error('[Ruckstuhl Global Configurator] Auto-open failed', error);
          opened = false;
          forceUnlock();
          try{ trigger.scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){}
        }
      });
    });
    return true;
  }

  function stop(){
    if(timer){ window.clearInterval(timer); timer = null; }
  }

  function init(){
    forceUnlock();
    if(openWhenReady()) return;
    timer = window.setInterval(function(){
      attempts += 1;
      if(openWhenReady()){
        stop();
        return;
      }
      if(attempts >= 60){
        stop();
        forceUnlock();
        const trigger = visibleTrigger();
        if(trigger){
          try{ trigger.scrollIntoView({behavior:'smooth', block:'center'}); }catch(error){}
        }
      }
    }, 100);
  }

  // Emergency release: even if an individual configurator throws, Escape/close must restore scrolling.
  document.addEventListener('click', function(event){
    if(event.target && event.target.closest && event.target.closest(CLOSE_SELECTOR)){
      window.setTimeout(forceUnlock, 0);
      window.setTimeout(function(){
        const stillOpen = document.querySelector('.rk-at-modal.is-open, .rk-rb-modal.is-open, .rk-tile-modal:not([hidden]), [data-rk-maglia-modal].is-open');
        if(stillOpen) emergencyClose(); else forceUnlock();
      }, 300);
    }
  }, true);

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape'){
      window.setTimeout(function(){
        const stillOpen = document.querySelector('.rk-at-modal.is-open, .rk-rb-modal.is-open, .rk-tile-modal:not([hidden]), [data-rk-maglia-modal].is-open');
        if(stillOpen) emergencyClose(); else forceUnlock();
      }, 40);
    }
  }, true);

  window.addEventListener('pageshow', forceUnlock);

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
